<template>
  <div class="config" v-if="localStore">
    <div id="titleDiv" class="row">
      <div class="flex" style="display: flex; align-items: center">Title:</div>
      <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
        <va-input
          label="Store Name"
          v-model="storeTitle"
          @change="storeChanged"
          placeholder="Store Title"
          style="display: flex; align-self: bottom"
        />
      </div>
    </div>

    <div id="visibleDiv" class="row">
      <div class="flex" style="display: flex; align-items: center">Visible in App:</div>
      <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
        <va-toggle v-model="visible" @change="storeChanged" />
      </div>
    </div>

    <div id="addressDiv">
      <h1>Address</h1>

      <div class="row">
        <div class="flex" style="display: flex; align-items: center">Street:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-input
            label="Street"
            v-model="storeStreet"
            placeholder="Store Street"
            style="display: flex; align-self: bottom"
            @change="storeChanged"
          />
        </div>
      </div>

      <div class="row">
        <div class="flex" style="display: flex; align-items: center">City:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-input
            label="City"
            v-model="storeCity"
            placeholder="Store City"
            style="display: flex; align-self: bottom"
            @change="storeChanged"
          />
        </div>
      </div>

      <div class="row">
        <div class="flex" style="display: flex; align-items: center">State:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-input
            label="State"
            v-model="storeState"
            placeholder="Store State"
            style="display: flex; align-self: bottom"
            @change="storeChanged"
          />
        </div>
      </div>

      <div class="row">
        <div class="flex" style="display: flex; align-items: center">Zip Code:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-input
            label="Zip Code"
            v-model="storeZip"
            placeholder="Store Zip Code"
            style="display: flex; align-self: bottom"
            @change="storeChanged"
          />
        </div>
      </div>
    </div>
    <br />

    <div id="themeDiv">
      <h1>App Theme</h1>

      <div id="mainFontDiv" class="row">
        <div class="flex" style="display: flex; align-items: center">Main Font:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-select label="Main Font" v-model="mainFont" searchable textBy="description" :options="fontList" />
        </div>
      </div>

      <div id="titleFontDiv" class="row">
        <div class="flex" style="display: flex; align-items: center">Title Font:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-select label="Title Font" v-model="titleFont" searchable textBy="description" :options="fontList" />
        </div>
      </div>

      <div id="lightDiv" class="row">
        <div class="flex" style="display: flex; align-items: center">Light:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-toggle v-model="light" @change="storeChanged" />
        </div>
      </div>

      <div id="primaryColorDiv">
        <h2>Primary Color</h2>

        <div class="row">
          <div class="flex md1">
            <va-color-square :value="primaryColor" />
          </div>
          <div class="flex md7">
            <va-advanced-color-picker v-model="primaryColor" />
          </div>
        </div>
      </div>

      <div id="accentColorDiv">
        <h2>Accent Color</h2>

        <div class="row">
          <div class="flex md1">
            <va-color-square :value="accentColor" />
          </div>
          <div class="flex md7">
            <va-advanced-color-picker v-model="accentColor" />
          </div>
        </div>
      </div>
    </div>

    <va-button @click="saveStoreConfig()" :disabled="!modified">Save</va-button>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebaseConfig')

export default {
  name: 'storePage',
  components: {},
  methods: {
    componentToHex: function (c) {
      var hex = c.toString(16)
      // eslint-disable-next-line
      return hex.length == 1 ? '0' + hex : hex
    },
    rgbToHex: function (c) {
      return '#' + this.componentToHex(c[0]) + this.componentToHex(c[1]) + this.componentToHex(c[2])
    },
    hexToRgb: function (hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : null
    },
    saveStoreConfig: async function () {
      this.setLocalStore()
      this.$store.commit('setLoading', true)

      var updateStore = fb.funcs.httpsCallable('updateStore')
      await updateStore({
        implnt: 'BRIM',
        storeId: this.localStore.id.toString(),
        store: this.localStore,
      })

      this.modified = false
      this.$store.commit('setLoading', false)
      this.$store.commit('setCurrentStore', this.localStore)
    },
    storeChanged: function (evt) {
      this.modified = true
    },
    setLocalStore: function () {
      this.localStore.title = this.storeTitle
      this.localStore.visible = this.visible
      this.localStore.address.street = this.storeStreet
      this.localStore.address.city = this.storeCity
      this.localStore.address.state = this.storeState
      this.localStore.address.zip = this.storeZip
      this.localStore.theme.titleFont = this.titleFont
      this.localStore.theme.bodyFont = this.mainFont
      this.localStore.theme.light = this.light
      this.localStore.theme.primaryColorRGB = this.primaryColorRGB
      this.localStore.theme.accentColorRGB = this.accentColorRGB
    },
  },
  computed: {
    primaryColor: {
      get: function () {
        return this.rgbToHex(this.primaryColorRGB)
      },
      set: function (hex) {
        this.primaryColorRGB = this.hexToRgb(hex)
        this.storeChanged(null)
      },
    },
    accentColor: {
      get: function () {
        return this.rgbToHex(this.accentColorRGB)
      },
      set: function (hex) {
        this.accentColorRGB = this.hexToRgb(hex)
        this.storeChanged(null)
      },
    },
  },
  data() {
    return {
      modified: false,
      storeTitle: '',
      visible: false,
      storeStreet: '',
      storeCity: '',
      storeState: '',
      storeZip: 0,
      mainFont: '',
      titleFont: '',
      light: false,
      primaryColorRGB: [0, 0, 0],
      accentColorRGB: [0, 0, 0],
      fontList: ['Loading Font options...'],
      localStore: {
        type: Object,
        required: false,
        default: { title: 'No Store', coupons: [] },
      },
    }
  },
  mounted: async function () {
    this.localStore = this.$store.getters.currentStore

    if (this.localStore.id === -1) {
      // Reset localstore so that the console doesn't complain
      this.localStore = {
        title: 'No Store',
        id: 0,
        coupons: [],
        address: {},
        theme: { primaryColorRGB: [0, 0, 0], accentColorRGB: [0, 0, 0] },
      }
      this.$router.push({ name: 'stores' })
    }

    this.storeTitle = this.localStore.title
    this.visible = this.localStore.visible
    this.storeStreet = this.localStore.address.street
    this.storeCity = this.localStore.address.city
    this.storeState = this.localStore.address.state
    this.storeZip = this.localStore.address.zip
    this.mainFont = this.localStore.theme.bodyFont
    this.titleFont = this.localStore.theme.titleFont
    this.light = this.localStore.theme.light
    this.primaryColorRGB = this.localStore.theme.primaryColorRGB
    this.accentColorRGB = this.localStore.theme.accentColorRGB

    var getFonts = fb.funcs.httpsCallable('getGoogleFonts')
    this.fontList = (await getFonts({})).data.map((font) => font.family)
  },
}
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}

.config {
  .va-card {
    margin-bottom: 0 !important;
  }
}

.va-input-wrapper,
.va-toggle {
  margin-bottom: 0;
}

#heading {
  font-size: 2.5em;
}

.storeDiv {
  width: 75%;
  margin: 1em;
  transition: all 0.3s ease-in-out;
  :hover {
    transform: scale(1.05);
  }
}

.no-scale {
  :hover {
    transform: scale(1);
  }
}
</style>
